import { render, staticRenderFns } from "./ContabilitaDocumentiListComponent.vue?vue&type=template&id=bf24f216&scoped=true"
import script from "./ContabilitaDocumentiListComponent.vue?vue&type=script&lang=js"
export * from "./ContabilitaDocumentiListComponent.vue?vue&type=script&lang=js"
import style0 from "./ContabilitaDocumentiListComponent.vue?vue&type=style&index=0&id=bf24f216&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf24f216",
  null
  
)

export default component.exports